import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Tutorial, TutorialProgresso} from '../models/tutorial';
import {ResponseBase} from '../models/response-base';
import {AuthenticationService} from './authentication.service';

@Injectable({
    providedIn: 'root'
})
export class TutorialService {

    private URL = environment.GATEWAY + 'tutorial';

    constructor(private http: HttpClient, private authenticationService: AuthenticationService) {
    }

    getProgresso(cedenteGuid: string, gestorGuid: string, nomeTutorial: string) {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        headers = headers.append('no-loader', 'true');
        return this.http.get<ResponseBase<TutorialProgresso>>(`${this.URL}/progresso/gestor/${gestorGuid}/cedente/${cedenteGuid}/${nomeTutorial}`, {headers});
    }

    updateProgresso(progresso: TutorialProgresso) {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        headers = headers.append('no-loader', 'true');
        return this.http.post<ResponseBase<TutorialProgresso>>(`${this.URL}/progresso/atualizar`, progresso, {headers});
    }

    getTutorial(nome: string) {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        headers = headers.append('no-loader', 'true');
        return this.http.get<ResponseBase<Tutorial>>(`${this.URL}/configuracao/${nome}`, {headers});
    }

    getIdTutorial(): string {
        const tutorial = this.getLocalStoraggeTutorial;
        if (tutorial) {
            return tutorial._id;
        }
    }

    setLocalStoragePassos(steps: any[]) {
        localStorage.setItem('passos', JSON.stringify(steps));
    }

    get getLocalStoragePassos() {
        return JSON.parse(localStorage.getItem('passos'));
    }

    setLocalStoragePassoAtual(step: any) {
        localStorage.setItem('passoAtual', JSON.stringify(step));
    }

    get getLocalStoragePassoAtual() {
        return JSON.parse(localStorage.getItem('passoAtual'));
    }


    setLocalStorageTutorial(tutorial: Tutorial) {
        localStorage.setItem('tutorial', JSON.stringify(tutorial));
    }

    get getLocalStoraggeTutorial() {
        return JSON.parse(localStorage.getItem('tutorial'));
    }

    public createStepsTutorial(tutorial: Tutorial) {
        const steps = [];
        tutorial.passos.forEach((passo, index) => {
            const step = {
                stepId: 'Id' + passo.ordemAtividade,
                id: passo.idBotaoAcao,
                anchorId: passo.ordemAtividade,
                content: passo.textoModal,
                title: passo.headerModal,
                placement: 'below',
                enableBackdrop: true,
                preventScrolling: true,
                alreadyDone: false,
                action: passo.ordemAtividade === 0 ? false : passo.ordemAtividade === 1 ? false : passo.ordemAtividade === 2 ? true : passo.ordemAtividade === 3,
                endBtnTitle: tutorial.passos.length === (index + 1) ? 'End' : ''
            };
            steps.push(step);

        });
        return steps;
    }

    public createAtualizarProgresso(ordemAtividade: number): TutorialProgresso {
        const currentUserValue = this.authenticationService.currentUserValue;
        const progresso = new TutorialProgresso();

        progresso.ativo = true;
        progresso.idCedente = currentUserValue.token.assignorGuid;
        progresso.idGestor = currentUserValue.token.userReferenceId;
        progresso.idTutorial = this.getIdTutorial();
        progresso.ordemAtividade = ordemAtividade;


        return progresso;
    }
}
